import * as api from "../generated-api";
import { apiCall } from "../common";

export const getDealLawFirms = (
  orgId: number,
  dealId: number,
  successCallback?: (lawFirm: api.DealLawFirm[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealLawFirm[]>(
    () => {
      return api.getDealLawFirms(orgId, dealId);
    },
    successCallback,
    errorCallback
  );
};

export const createDealLawFirmWithMember = (
  orgId: number,
  dealId: number,
  createDealLawFirmData: api.DealLawFirmAndPersonCreate,
  successCallback?: (lawFirm: api.DealLawFirm) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealLawFirm>(
    () => {
      return api.createDealLawFirmWithMember(
        orgId,
        dealId,
        createDealLawFirmData
      );
    },
    successCallback,
    errorCallback
  );
};
